import { IRequest } from 'types';

export type TMeterRequestPayload = {
  id: string;
  number: string;
  created_at: string;
  common_status: string;
};

export const mapCreatedRequestToHistoryMeters = (
  createdRequest: Pick<IRequest, '_id' | 'number' | 'created_at' | 'status'>
): TMeterRequestPayload => ({
  id: createdRequest._id,
  number: createdRequest.number,
  created_at: createdRequest.created_at,
  common_status: createdRequest.status,
});

export const mergeHistoryRequest = (
  request: TMeterRequestPayload,
  responseRequest?: Partial<TMeterRequestPayload> | null
): TMeterRequestPayload => ({
  ...request,
  ...(responseRequest || {}),
  number: responseRequest?.number || request.number,
  created_at: responseRequest?.created_at || request.created_at,
  common_status: responseRequest?.common_status || request.common_status,
});
